import React from "react";
import MembershipStore from "../MembershipStore";
import { inject, observer } from "mobx-react";  
import ProgramAndLevels from "./ProgramAndLevels";
import { MembershipOptionWrapper, SetupDetails } from "../../../shared/styles";
import { ItemHeader, MembershipRelatedItems, UsageSection } from "../../../shared/components";
import { CountryWithStateModel, ServiceAndMembershipOptionsPageModel } from "../../../shared/models";
import { PricingPageService, RelatedItemsService } from "../../../shared/services";

type Props = {
    membershipStore?: MembershipStore;
    sourceId?: string | null;
    countriesWithState: CountryWithStateModel[];
};
@inject('membershipStore')
@observer
class OptionsPage extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <SetupDetails>
                <MembershipOptionWrapper>
                    <ItemHeader header="Membership Options" />
                    {/*Hide due to requirements*/}
                    {false && <ProgramAndLevels />}
                    {false && (
                        <UsageSection
                            updateOptionsPage={(optionsPage: ServiceAndMembershipOptionsPageModel) =>
                                this.props.membershipStore?.updateOptionsPage(optionsPage)
                            }
                            toggleAddBenefitModal={() => this.props.membershipStore?.toggleAddBenefitModal()}
                            optionsPage={
                                this.props.membershipStore?.optionsPage || new ServiceAndMembershipOptionsPageModel()
                            }
                            showAddBenefitModal={this.props.membershipStore?.showAddBenefitModal === true}
                            pricingPageData={this.props.membershipStore?.pricingPageData || new PricingPageService()}
                        />
                    )}

                    <MembershipRelatedItems
                        sourceId={this.props.sourceId || ''}
                        realtedItemService={this.props.membershipStore?.realtedItemService || new RelatedItemsService()}
                        countriesWithState={this.props.countriesWithState }
                    />
                </MembershipOptionWrapper>
            </SetupDetails>
        );
    }
}

export default OptionsPage;
